import { createReducer, on } from '@ngrx/store';
import * as actions from '../actions';

export const FNAFeatureKey = 'fna';

export interface FNAState {
  loadFNA: any;
  loadFNAResponse: any;
  loadFNAFailure: any;
}

export const initialState: FNAState = {
  loadFNA: undefined,
  loadFNAResponse: undefined,
  loadFNAFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(actions.loadFNA, (state, action) => ({
    ...state,
    loadFNA: action.request
  })),
  on(actions.loadFNASuccess, (state, action) => ({
    ...state,
    loadFNAResponse: action.response
  })),
  on(actions.loadFNAFailure, (state, action) => ({
    ...state,
    loadFNAFailure: action.error
  }))
);

export const getFNA = (state: FNAState) => state.loadFNAResponse;
